<template lang="pug">
div
  vue-context.deviceContext(ref="menuDevice")
    template(slot-scope="child")
      li.header(v-if="child.data")
        | {{$options.filters.translate('Move', lang)}}
        br
        strong {{child.data.device.name}}
        br
        | {{$options.filters.translate('from Network', lang)}}:
        br
        strong {{networks.find(net => net.id === child.data.device.network).name}} - {{networks.find(net => net.id === child.data.device.network).description}}
        br
        | {{$options.filters.translate('to Network', lang)}}:
      li(v-if="child.data && network.id !== $store.getters.filterNetwork" v-for="network in networks" :key="network.id")
        a(href="#" @click.prevent="moveTo(child.data.device, network)") {{network.name}} - {{network.description}}

  device-detail(v-if='showModal', :lang='lang', @enableDevice='enableDevice', @removeDevice='removeDevice', @refreshSs='refreshScreenshot', @restartApp='restartApp', @restartView='restartView', @restartDevice='restartDevice', @close='closeModal', :deviceIndex='deviceDetailIndex')
  transition(name='fade', mode='out-in', v-if="view === 'thumbs'")
    .row
      template(v-if="$store.getters.hasRole(['admin'])")
        w2-device(v-for='(device, index) in devices', :lang='lang', @contextmenu="$refs.menuDevice.open($event, { device })", @enableDevice='enableDevice', @removeDevice='removeDevice', @deactivateDevice='deactivateDevice', @activateDevice='activateDevice', @refreshSs='refreshScreenshot', @restartApp='restartApp', @restartView='restartView', @restartDevice='restartDevice', @openDetails='openDeviceDetail(device.id)', @generateServicePin='generateServicePin(device)', :key='index', :device='device', :showModal='showModal')
      template(v-else)
        w2-device(v-for='(device, index) in devices', :lang='lang', @enableDevice='enableDevice', @removeDevice='removeDevice', @deactivateDevice='deactivateDevice', @activateDevice='activateDevice', @refreshSs='refreshScreenshot', @restartApp='restartApp', @restartView='restartView', @restartDevice='restartDevice', @openDetails='openDeviceDetail(device.id)' :key='index', :device='device', :showModal='showModal')
  transition(name='fade', mode='out-in', v-if="view === 'list'")
    div
      .row
        .col-sm-12
          table.table.table-hover
            thead
              tr
                th
                  export-excel(:data="dataForExcel" class="btn text-success fa fa-lg fa-file-export" v-tooltip.bottom="$options.filters.translate('exportExcel', lang)") &nbsp;
                th
                  .form-inline
                    .form-group
                      .input-group
                        input.form-control.input-sm.length(type="text" :value="allDevices.length" disabled)
                        .input-group-addon.input-sm(@click="cancelAllDevicesFilter()" v-tooltip.bottom="$options.filters.translate('Clear filters', lang)")
                          i.fa.fa-xs.fa-times-circle.text-warning(aria-hidden="true")
                th(v-for="(column, index) in columns", :key='index' v-if="index !==0")
                  .form-inline(v-if="column.search")
                    .form-group
                      .input-group
                        .input-group-addon.input-sm(v-if="column.inverse" v-tooltip.bottom="$options.filters.translate('Negation can be used \"!\"', lang)")
                          i.fa.fa-xs.fa-question-circle.text-primary(aria-hidden="true")
                        input.form-control.input-sm(type="text" v-model="columns[index].filter" :placeholder="(column.field === 'cpuLoad' || column.field === 'cpuTemp' || column.field === 'diskUsagePercent') ? $options.filters.translate('greater then', lang) : ''" @keydown.esc="cancelDevicesFilter(index)")
                        .input-group-addon.input-sm(@click="cancelDevicesFilter(index)" v-tooltip.bottom="$options.filters.translate('Clear filter', lang)")
                          i.fa.fa-xs.fa-times-circle.text-warning(aria-hidden="true")
              tr
                th no
                th(v-for="(column, index) in columns", :key='index', class="active: sortKey.name === column.name")
                  a(v-if="column.field" href="#" @click="sortBy(column.field)" :class="{active: sortKey === column.field}") {{$options.filters.translate(column.name, lang)}}
                  a(v-else) {{$options.filters.translate(column.name, lang)}}
            tbody
              template(v-if="$store.getters.hasRole(['admin'])")
                w2-device-row(v-for='(device, index) in devices', @enableDevice='enableDevice', :lang='lang', @contextmenu="$refs.menuDevice.open($event, { device })", @refreshSs='refreshScreenshot', @restartApp='restartApp', @restartView='restartView', @restartDevice='restartDevice', @removeDevice='removeDevice', @activateDevice='activateDevice', @openDetails='openDeviceDetail(device.id)', :key='index' :index='index+1', :device='device', :showModal='showModal')
              template(v-else)
                w2-device-row(v-for='(device, index) in devices', @enableDevice='enableDevice', :lang='lang', @refreshSs='refreshScreenshot', @restartApp='restartApp', @restartView='restartView', @restartDevice='restartDevice', @removeDevice='removeDevice', @activateDevice='activateDevice', @openDetails='openDeviceDetail(device.id)', :key='index' :index='index+1', :device='device', :showModal='showModal')
</template>

<script>
import Device from '@/components/device/Device'
import DeviceRow from '@/components/device/DeviceRow'
import DeviceDetail from '@/components/device/DeviceDetail'
export default {
  name: 'device-list',
  props: ['lang'],
  components: {
    'w2-device': Device,
    'w2-device-row': DeviceRow,
    'device-detail': DeviceDetail
  },
  data () {
    return {
      getDevicesInterval: 30,
      getDevicesIntervalObj: null,
      columns: [
        {
          'search': false,
          'field': false,
          'name': 'State',
          'inverse': false
        },
        {
          'search': true,
          'field': 'hbtime',
          'name': 'Last HB',
          'inverse': false
        },
        {
          'search': false,
          'field': false,
          'name': 'Actions',
          'inverse': false
        },
        {
          'search': true,
          'field': 'name',
          'name': 'Name',
          'inverse': false
        },
        {
          'search': true,
          'field': 'description',
          'name': 'Descr.',
          'inverse': false
        },
        {
          'search': true,
          'field': 'localIP',
          'name': 'IP',
          'inverse': false
        },
        {
          'search': true,
          'field': 'version',
          'name': 'Ver.',
          'inverse': true
        },
        {
          'search': true,
          'field': 'kfc_kiosk',
          'name': 'Cookbook version',
          'inverse': true
        },
        {
          'search': true,
          'field': 'mb',
          'name': 'Motherboard',
          'inverse': true
        },
        {
          'search': true,
          'field': 'cpu',
          'name': 'CPU',
          'inverse': true
        },
        {
          'search': true,
          'field': 'cpuLoad',
          'name': 'CPU %',
          'inverse': false
        },
        {
          'search': true,
          'field': 'cpuTemp',
          'name': 'Temp.',
          'inverse': false
        },
        {
          'search': true,
          'field': 'diskUsagePercent',
          'name': 'Disk',
          'inverse': false
        }
      ],
      showModal: false,
      sortKey: 'name',
      reverse: false,
      networks: this.$store.getters.networks,
      device: {},
      deviceDetailIndex: 0
    }
  },
  computed: {
    dataForExcel () {
      const data = []
      this.allDevices.forEach(device => {
        const tmp = {...device}
        tmp.sn = device.hardware ? device.hardware.serial : ''
        tmp.printer = device.printer ? device.printer.type : ''
        tmp.printerSN = device.printer ? device.printer.sn : ''
        tmp.terminal = device.terminal ? device.terminal.type : ''
        tmp.TID = device.terminal ? device.terminal.tid : ''
        tmp.createdAt = this.$options.filters.formatDateTime(device.createdAt)
        tmp.initialActivationAt = this.$options.filters.formatDateTime(tmp.initialActivationAt)
        tmp.hbtime = this.$options.filters.formatDateTime(tmp.hbtime)
        tmp.freeMem = this.$options.filters.memFormat(tmp.freeMem)
        tmp.cpuLoad = this.$options.filters.cpuFormat(tmp.cpuLoad)
        tmp.failure = JSON.stringify(tmp.failure)
        tmp.network = this.networks.find(network => network.id === device.network).name
        tmp.motherboard = this.$options.filters.hardwareMotherboardFormat(tmp.hardware)
        tmp.cpu = this.$options.filters.hardwareCpuFormat(tmp.hardware)
        delete tmp.id
        delete tmp.screenshot
        delete tmp.updatedAt
        delete tmp.reportErrors
        delete tmp.screens
        delete tmp.hardware
        delete tmp.software
        delete tmp.publicIP
        delete tmp.gatewayIP
        delete tmp.kiosk_status
        data.push(tmp)
      })
      return data
    },
    network () {
      return this.$store.getters.filterNetwork
    },
    openDetailId () {
      return this.$store.getters.openDetailId
    },
    allDevices () {
      // eslint-disable-next-line no-unused-expressions
      let order = (this.reverse) ? 'desc' : 'asc'
      let tmpDevices = this.$store.getters.filteredDevices
      switch (this.sortKey) {
        case 'cpu':
          tmpDevices = tmpDevices.sort(this.sortByCpu)
          if (this.reverse) {
            tmpDevices = tmpDevices.reverse()
          }
          break
        case 'mb':
          tmpDevices = tmpDevices.sort(this.sortByMb)
          if (this.reverse) {
            tmpDevices = tmpDevices.reverse()
          }
          break
        case 'kfc_kiosk':
          tmpDevices = tmpDevices.sort(this.sortByCookbookVersion)
          if (this.reverse) {
            tmpDevices = tmpDevices.reverse()
          }
          break
        default:
          tmpDevices = this.$_.orderBy(tmpDevices, this.sortKey, order)
          break
      }
      // column filters
      this.columns.forEach(column => {
        if (column.filter && column.field) {
          switch (column.field) {
            case 'kfc_kiosk':
              tmpDevices = tmpDevices.filter(device => {
                let software = device.software
                if (column.filter[0] === '!') {
                  if (!software || !software.localConfig || !software.localConfig.kiosk || !software.localConfig.kiosk.kfc_kiosk_version) {
                    return true
                  }
                  const search = column.filter.toLowerCase().substr(1)
                  return software.localConfig.kiosk.kfc_kiosk_version !== null && software.localConfig.kiosk.kfc_kiosk_version.toLowerCase().lastIndexOf(search) < 0
                }
                return software && (software.localConfig.kiosk.kfc_kiosk_version.toLowerCase().search(column.filter.toLowerCase()) >= 0)
              })
              break
            case 'footer':
              tmpDevices = tmpDevices.filter(device => {
                let software = device.software
                if (column.filter[0] === '!') {
                  if (!software || !software.localConfig || !software.localConfig.kiosk || !software.localConfig.kiosk.printer || !software.localConfig.kiosk.printer.footerImgPath) {
                    return true
                  }
                  const search = column.filter.toLowerCase().substr(1)
                  return software.localConfig.kiosk.printer.footerImgPath !== null && software.localConfig.kiosk.printer.footerImgPath.toLowerCase().lastIndexOf(search) < 0
                }
                return software && (software.localConfig.kiosk.printer.footerImgPath.toLowerCase().search(column.filter.toLowerCase()) >= 0)
              })
              break
            case 'cpu':
              tmpDevices = tmpDevices.filter(device => {
                let hardware = device.hardware
                if (column.filter[0] === '!') {
                  const search = column.filter.toLowerCase().substr(1)
                  return !hardware || (hardware && ((hardware.cpu).toLowerCase().lastIndexOf(search) < 0))
                }
                return hardware && (hardware.cpu.toLowerCase().search(column.filter.toLowerCase()) >= 0)
              })
              break
            case 'mb':
              tmpDevices = tmpDevices.filter(device => {
                let hardware = device.hardware
                if (column.filter[0] === '!') {
                  const search = column.filter.toLowerCase().substr(1)
                  return !hardware || (hardware && ((hardware.motherboard.manufacturer + hardware.motherboard.productName).toLowerCase().lastIndexOf(search) < 0))
                }
                return hardware && ((hardware.motherboard.manufacturer + hardware.motherboard.productName).toLowerCase().search(column.filter.toLowerCase()) >= 0)
              })
              break
            case 'cpuLoad':
              tmpDevices = tmpDevices.filter(device => {
                column.filter = column.filter.replace(',', '.')
                return parseFloat(device[column.field]) > parseFloat(column.filter)
              })
              break
            case 'cpuTemp':
              tmpDevices = tmpDevices.filter(device => {
                column.filter = column.filter.replace(',', '.')
                return parseFloat(device[column.field]) > parseFloat(column.filter)
              })
              break
            case 'diskUsagePercent':
              tmpDevices = tmpDevices.filter(device => {
                column.filter = column.filter.replace(',', '.')
                return parseFloat(device[column.field]) > parseFloat(column.filter)
              })
              break
            case 'hbtime':
              tmpDevices = tmpDevices.filter(device => this.$options.filters.formatDateTime(device[column.field]).search(column.filter) >= 0)
              break
            default:
              tmpDevices = tmpDevices.filter(device => {
                if (column.filter[0] === '!') {
                  const search = column.filter.toLowerCase().substr(1)
                  return device[column.field] !== null && device[column.field].toLowerCase().lastIndexOf(search) < 0
                }
                return device[column.field] !== null && device[column.field].toLowerCase().search(column.filter.toLowerCase()) >= 0
              })
              break
          }
        }
      })
      return tmpDevices
    },
    devices () {
      return this.$_.slice(this.allDevices, (this.$store.state.devicePage - 1) * this.$store.state.devicePerPage, this.$store.state.devicePage * this.$store.state.devicePerPage)
    },
    view () {
      return this.$store.state.deviceViewType
    },
    previousClass () {
      return (this.page === 1) ? 'disabled' : ''
    },
    nextClass () {
      return (this.devices.length !== this.perPage) ? 'disabled' : ''
    }
  },
  methods: {
    cancelDevicesFilter (index) {
      this.$set(this.columns[index], 'filter', '')
      this.$store.commit('SET_DEVICES_PAGE', 1)
    },
    cancelAllDevicesFilter () {
      this.columns.forEach(column => {
        this.$set(column, 'filter', '')
      })
      this.$store.commit('SET_DEVICES_PAGE', 1)
    },
    sortByMb (a, b) {
      const aVal = (a.hardware) ? a.hardware.motherboard.manufacturer + a.hardware.motherboard.productName : 'n/a'
      const bVal = (b.hardware) ? b.hardware.motherboard.manufacturer + b.hardware.motherboard.productName : 'n/a'
      if (aVal < bVal) {
        return -1
      }
      if (aVal > bVal) {
        return 1
      }
      return 0
    },
    sortByCpu (a, b) {
      const aVal = (a.hardware) ? a.hardware.cpu : 'n/a'
      const bVal = (b.hardware) ? b.hardware.cpu : 'n/a'
      if (aVal < bVal) {
        return -1
      }
      if (aVal > bVal) {
        return 1
      }
      return 0
    },
    sortByCookbookVersion (a, b) {
      const aVal = (a.software &&
        a.software.localConfig &&
        a.software.localConfig.kiosk &&
        a.software.localConfig.kiosk.kfc_kiosk_version) ? a.software.localConfig.kiosk.kfc_kiosk_version : 'n/a'
      const bVal = (b.software &&
        b.software.localConfig &&
        b.software.localConfig.kiosk &&
        b.software.localConfig.kiosk.kfc_kiosk_version) ? b.software.localConfig.kiosk.kfc_kiosk_version : 'n/a'
      if (aVal < bVal) {
        return -1
      }
      if (aVal > bVal) {
        return 1
      }
      return 0
    },
    moveTo (device, network) {
      const self = this
      let reply = confirm(`${this.$options.filters.translate('Do you really want to move', this.lang)} ${device.name} ${this.$options.filters.translate('to network', this.lang)} ${network.name}?`)
      if (reply) {
        this.$http.patch(`device/${device.id}`, {network: network.id})
          .then(response => {
            return response.json()
          })
          .then(data => {
            if (!data || !data.network || !data.network.id) {
              self.$notify(self.$options.filters.translate('Failed to move Kiosk', self.lang), 'error')
              return
            }
            data.network = data.network.id
            self.$store.commit('SET_DEVICE', data)
            this.$notify(this.$options.filters.translate('Kiosk moved', this.lang), 'success')
          })
      }
    },
    sortBy (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
      this.sortKey = sortKey
    },
    changePerPage (val) {
      this.page = 1
      this.perPage = val
      this.getScreens()
    },
    getPrevious () {
      if (this.page !== 1) {
        this.page -= 1
        this.getScreens()
      }
    },
    getNext () {
      if (this.payments.length === this.perPage) {
        this.page += 1
        this.getScreens()
      }
    },
    openDeviceDetail (deviceId) {
      this.deviceDetailIndex = this.$store.getters.filteredDevices.findIndex(device => device.id === deviceId)
      this.showModal = true
    },
    removeDevice (deviceId) {
      const self = this
      let reply = confirm(this.$options.filters.translate('Do you really want to remove the Kiosk?', this.lang))
      if (reply) {
        let reply2 = confirm(this.$options.filters.translate('Please confirm the removal of the Kiosk!', this.lang))
        if (reply2) {
          self.$http.post('device/remove', {'device': deviceId})
            .then(response => {
              if (response.ok) {
                self.$store.commit('REMOVE_DEVICE', deviceId)
                self.$notify(this.$options.filters.translate('Kiosk removed', this.lang), 'success')
              } else {
                self.$notify(this.$options.filters.translate('Failed to remove Kiosk', this.lang), 'error')
              }
            })
        }
      }
    },
    generateServicePin (device) {
      this.$http.post('device/servicePin', {'id': device.id})
        .then(response => {
          const otp = this.$options.filters.otpFormat(response.body.otp)
          this.$notify(`<h3>${this.$options.filters.translate('Service PIN', this.lang)}:</h3><h3>${otp}</h3>`, 'success', { mode: 'html', permanent: true })
        }, response => {
          this.$notify(`<h3>${response.bodyText}</h3>`, 'error', { mode: 'html', permanent: true })
        })
    },
    activateDevice (device) {
      let reply = confirm(this.$options.filters.translate('Do you really want to activate the Kiosk?', this.lang))
      if (reply) {
        this.$http.post('device/activate', {'device': device.id})
          .then(response => {
            if (response.ok) {
              this.$notify(this.$options.filters.translate('Kiosk activated', this.lang), 'success')
              device.active = true
              this.$store.commit('SET_DEVICE', device)
              this.getDevices()
            }
          }, response => {
            this.$notify(this.$options.filters.translate('Kiosk activation fail', this.lang) + `<br>${response.bodyText}`, 'error', { mode: 'html' })
          })
      }
    },
    deactivateDevice (device) {
      let reply = confirm(this.$options.filters.translate('Do you really want to deactivate the Kiosk?', this.lang))
      if (reply) {
        this.$http.post('device/deactivate', {'device': device.id})
          .then(response => {
            if (response.ok) {
              this.$notify(this.$options.filters.translate('Kiosk deactivated', this.lang), 'success')
              device.active = false
              this.$store.commit('SET_DEVICE', device)
              this.getDevices()
            }
          }, response => {
            this.$notify(this.$options.filters.translate('Kiosk deactivation fail', this.lang) + `<br>${response.bodyText}`, 'error', { mode: 'html' })
          })
      }
    },
    enableDevice (args) {
      const id = args.id
      const enable = args.enable
      const comm = {
        action: this.$options.filters.translate('disable', this.lang),
        command: 'SET SCREENOFF'
      }
      if (enable) {
        comm.action = this.$options.filters.translate('enable', this.lang)
        comm.command = 'SET SCREENON'
      }
      let reply = confirm(this.$options.filters.translate('Do you really want to', this.lang) + ` ${comm.action} ` + this.$options.filters.translate('screen', this.lang) + ` ?`)
      if (reply) {
        this.$http.post('commands/issue', {'device': id, 'command': comm.command})
          .then(response => {
            this.$http.patch('device/' + id, {'enabled': enable})
              .then(response => {
                this.$notify(this.$options.filters.translate('Command sent', this.lang), 'success')
                this.getDevices(false)
              })
          })
      }
    },
    refreshScreenshot (id) {
      this.$http.post('commands/issue', {'device': id, 'command': 'GET SCREENSHOT'})
        .then(response => {
          console.log(response)
          if (response.ok) {
            this.$notify(this.$options.filters.translate('Screenshot command has been sent', this.lang), 'success')
          } else {
            this.$notify(this.$options.filters.translate('Failed to send screenshot command', this.lang), 'error')
          }
        })
    },
    restartView (id) {
      let reply = confirm(this.$options.filters.translate('Please confirm view restart command.', this.lang))
      if (reply) {
        this.$http.post('commands/issueSecure', {'device': id, 'command': 'RESTART VIEW'})
          .then(response => {
            this.$notify(this.$options.filters.translate('View restart command has been sent', this.lang), 'success')
          })
      }
    },
    restartApp (id) {
      let reply = confirm(this.$options.filters.translate('Please confirm app restart command.', this.lang))
      if (reply) {
        this.$http.post('commands/issueSecure', {'device': id, 'command': 'RESTART APP'})
          .then(response => {
            this.$notify(this.$options.filters.translate('App restart command has been sent', this.lang), 'success')
          })
      }
    },
    restartDevice (id) {
      let reply = confirm(this.$options.filters.translate('Please confirm kiosk restart command.', this.lang))
      if (reply) {
        this.$http.post('commands/issueSecure', {'device': id, 'command': 'RESTART PLAYER'})
          .then(response => {
            this.$notify(this.$options.filters.translate('Kiosk restart command has been sent', this.lang), 'success')
          })
      }
    },
    closeModal () {
      this.showModal = false
    },
    getDevices (showLoader = true) {
      this.$http.get(`device/${this.$route.params.type}`, {params: {showLoader}})
        .then(response => {
          return response.json()
        })
        .then(data => {
          const resultArray = []
          for (let key in data) {
            resultArray.push(data[key])
          }
          if (showLoader) {
            this.$store.commit('SET_DEVICES', resultArray)
          } else {
            this.$store.commit('SET_DEVICES_NOT_PAGE', resultArray)
          }
          // openDetail if it in request
          if (typeof this.openDetailId !== 'undefined') {
            this.openDeviceDetail(this.openDetailId)
          }
        })
    },
    connectIoNetwork () {
      if (process.env.NODE_ENV !== 'production') {
        console.log('connectIoNetwork', { network: this.network })
      }
      let self = this
      let url = '/sockets/joinNetworkStatuses'
      let data = { network: this.network }
      this.$io.socket.get(url, data, function (resData, jwres) {
        self.subscribeIoNetwork()
      })
      this.$io.socket.on('reconnect', function () {
        if (process.env.NODE_ENV !== 'production') {
          console.log('reconnect')
        }
        self.connectIoNetwork()
      })
    },
    subscribeIoNetwork () {
      const self = this
      this.$io.socket.off('message')
      this.$io.socket.on('message', function (msg) {
        if (process.env.NODE_ENV !== 'production') {
          if (process.env.NODE_ENV !== 'production') {
            console.log('message', msg)
          }
        }
        let hbScreen = self.$_.filter(self.devices, ['id', msg.device.id])[0]
        if (hbScreen) {
          switch (msg.messageType) {
            case 'status':
              self.$store.commit('SET_DEVICE', msg.device)
              break
            case 'newScreenshot':
              self.$set(hbScreen.screenshot, 0, msg.newscreenshot[0])
              break
            // case 'paymentLog':
            //   hbScreen.payments.push(msg.payment)
            //   break
            // case 'error':
            //   hbScreen.matrixerrors.push(msg.error)
            //   break
          }
        }
      })
    }
  },
  watch: {
    network (oldValue, newValue) {
      this.connectIoNetwork()
    }
  },
  created () {
    this.getDevices()
    this.getDevicesIntervalObj = setInterval(() => {
      this.getDevices(false)
    }, this.getDevicesInterval * 1000)
  },
  mounted () {
    this.connectIoNetwork()
  },
  destroyed () {
    clearInterval(this.getDevicesIntervalObj)
    this.$io.socket.off('message')
  }
}
</script>
<style lang="sass" scoped>
.form-inline .input-group .form-control.length
  width: 60px
.input-group-addon
  cursor: pointer
  &.all
    border-color: rgb(153, 153, 153)
    border-right-width: 1px
    border-right-style: solid
    border-left-width: 1px
    border-left-style: solid
a
  color: white
  font-weight: normal
  text-decoration: none !important

  &.active
    font-weight: bold
    text-decoration: underline !important
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceList.vue